import {Injectable} from '@angular/core';
import {AcceptedQuestions, ChangedQuestionsInterface, TeamAnswer, TriviaRound, TriviaRoundQuestion} from '@core/models';
import { GameService } from './game.service';
import { RoundAnswers } from '@core/models/game/round-answers.interface';
import { GameHelper } from '@core/helpers';

@Injectable({
  providedIn: 'root'
})
export class ChangeAnswerService {

  constructor() {
  }

  changeQuestionAnswer(data: {
    changedQuestions: ChangedQuestionsInterface,
    roundId: string,
    questionId: string,
    answerOption: string
  }): ChangedQuestionsInterface {
    const {changedQuestions, roundId, questionId, answerOption} = data;
    if (changedQuestions[roundId][questionId].answers.includes(answerOption)) {
      changedQuestions[roundId][questionId].answers = changedQuestions[roundId][questionId].answers
      .filter(answer => answer !== answerOption);
    } else {
      const newReference = [...changedQuestions[roundId][questionId].answers];
      newReference.push(answerOption)
      changedQuestions[roundId][questionId].answers = newReference;
    }
    return changedQuestions;
  }

  // prepareSubmitData(changedQuestions: ChangedQuestionsInterface,
  //                   gameRounds: { trivia_round: TriviaRound, round_questions_count: number }[]): AcceptedQuestions {
  //   let acceptedQuestions: AcceptedQuestions = {};
  //   for (const round in changedQuestions) {
  //     if (changedQuestions[round]) {
  //       acceptedQuestions[round] = [];
  //       for (const question in changedQuestions[round]) {
  //         if (changedQuestions[round][question].isAccepted) {
  //           acceptedQuestions = this.getChangedAnswers(round, question, acceptedQuestions, changedQuestions, gameRounds);
  //         }
  //       }
  //     }
  //   }
  //   return acceptedQuestions;
  // }

  // getChangedAnswers(roundId: string,
  //                   questionId: string,
  //                   acceptedQuestions: AcceptedQuestions,
  //                   changedQuestions: ChangedQuestionsInterface,
  //                   gameRounds: { trivia_round: TriviaRound, round_questions_count: number }[]): AcceptedQuestions {
  //   const prevRound: TriviaRound = gameRounds.find(r => r.trivia_round.round_id === roundId).trivia_round;
  //   const prevQuestion = prevRound.trivia_round_questions.find(q => q.question_id === questionId);
  //   const finalAnswers = {};
  //   for (const answer in prevQuestion.question.question_json.answers) {
  //     finalAnswers[answer] = changedQuestions[roundId][questionId].answers.includes(answer);
  //   }
  //   acceptedQuestions[roundId].push({question_id: questionId, answers: finalAnswers});
  //   return acceptedQuestions;
  // }

  setDefaultChangedQuestions(questions: TriviaRoundQuestion[],
                      roundId: string,
                      changedQuestions: ChangedQuestionsInterface): ChangedQuestionsInterface {
    changedQuestions[roundId] = {};
    for (const question of questions) {
      const newChangedQuestions = []
      question.question.right_answers.forEach(e => {
        newChangedQuestions.push(GameHelper.uniformApostrophe<string>(e))
      })
      changedQuestions[roundId][question.question.question_id] = {
        answers: newChangedQuestions, 
        questionTypeId: question.question.question_type.question_type_id, 
        isAccepted: false
      };
    }
    return changedQuestions;
  }
}
